import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Routing } from "../../data/Constants/Routing";
import LoadingWidget from "../../screens/LoadingWidget";
import AdministrationScreen from "../../screens/AdministrationScreen";

const Router: React.FC = () => {
    return (
        <Suspense fallback={<LoadingWidget />}>
            <Routes>

                <Route
                    path={Routing.Administration.Route}
                    element={<AdministrationScreen />} />

                <Route
                    path={Routing.Administration.Redirect}
                    element={<Navigate replace to={Routing.Administration.Execution.Navigate()} />} />

            </Routes>
        </Suspense>
    );
};

export default Router;
